import React, { useEffect } from 'react';
import { useGeocoder } from '@innovyze/stylovyze/lib/hooks/useGeocoder';
import { EllipsisWrapper } from './AddressLocation.styles';
/**
 * Display address retrieved from coordinates
 */
export const AddressLocation = ({ coordinates, ellipsis, }) => {
    const { getAddress, address } = useGeocoder();
    useEffect(() => {
        getAddress(...coordinates);
    }, [coordinates]);
    const contentArray = address
        ? [address.address, address.place].filter(Boolean)
        : coordinates;
    const content = contentArray.join(', ');
    if (ellipsis) {
        return React.createElement(EllipsisWrapper, { title: content }, content);
    }
    return React.createElement(React.Fragment, null, content);
};
AddressLocation.defaultProps = {};
export default AddressLocation;
